import { merge } from "lodash-es";
import { sharedTranslations } from "../../shared-translations.js";

export const trivagodealsSpecificTranslations = {
  "trivagodeals-footer": {
    "how-works": {
      title: "How does trivago DEALS work?",
      text: "When you book with trivago DEALS, rest assured you're choosing a licensed trivago brand, with secure bookings handled by our trusted partner, Holisto.",
    },
  },
  faq: {
    "question-sections": {
      "trivago-deals": {
        header: "Trivago DEALS",
        questions: {
          question0: {
            question: "What's the difference between trivago and trivago Deals?",
            answer:
              "trivago and trivago Deals both help you find great hotel deals, but they work in different ways:\n\ntrivago: Think of trivago as a search engine for hotels. It compares prices from lots of different booking sites (like Expedia, Booking.com, and Hotels.com) so you can see who has the best deal. You then click through to the booking site to make your reservation.\n\ntrivago Deals: trivago Deals is a booking platform where you can book your hotel directly. They have special deals and discounts that you won't find anywhere else.",
          },
          question1: {
            question: "Can I use my trivago account to log in to trivago Deals?",
            answer:
              "Not yet! trivago and trivago Deals have separate accounts right now. This means you'll need to create a new account on trivago Deals to book those awesome deals.\n\nBut we hear you! We're working on making it possible to use your trivago account for trivago Deals in the future. Stay tuned for updates!",
          },
          question2: {
            question: "What's the difference between trivago Deals and trivago Member Deals?",
            answer:
              "Both trivago Deals and trivago Member Deals help you save money on hotels, but they work in different ways:\n\ntrivago Deals: This is a service brought to you by trivago and Holisto, an online travel agency that offers hotel rooms all over the world. trivago Deals often has really good prices, and you can book your hotel directly on their platform.\n\ntrivago Member Deals: These are special prices just for trivago members! You'll find them when you search for hotels on trivago. Just sign in to your trivago account to unlock these extra savings.",
          },
          question3: {
            question: "Can I find trivago Deals on trivago?",
            answer:
              "Not directly within the trivago search results. trivago Deals is a separate platform with its own website. You can find trivago Deals through other travel search engines like Google Hotels.",
          },
        },
      },
    },
  },
  "html-metadata": {
    "brand-name": "trivago DEALS",
  },
} as const;

export type ITrivagodealsSpecificTranslations = typeof trivagodealsSpecificTranslations;

const trivagodealsTranslations = merge({}, sharedTranslations, trivagodealsSpecificTranslations);
export const translations = {
  dictionary: trivagodealsTranslations,
  language: "EN",
};
